@if(availableOrgUnitNames){
    <div class="org-unit-table-cell position-relative">
        <tm-filter-input-selector [value]="updatedOrgUnit.name" 
                                  [labelValue]="null" 
                                  [list]="availableOrgUnitNames" 
                                  (onNewOrgUpdated)="onOrgUpdated($event)"></tm-filter-input-selector>
    

        <div class="org-unit-table-cell-actions">
            <button class="btn btn-sm edit-btn edit-btn-save me-1" 
                    [disabled]="!updatedOrgUnit.name" 
                    (click)="save(updatedOrgUnit)">{{'orgUnits_save' | translate }}</button>
            <button class="btn btn-sm btn-default" 
                    (click)="cancel()"><i class="fa fa-times"></i></button>
        </div>
    </div> 
}